module.exports = __webpack_public_path__ + "img/Methodical Organiser.97696c93.svg";